export default __webpack_public_path__ + "static/media/material.bed967e2.mp3";